import { FC } from 'react';
import { BsFillTagFill } from 'react-icons/bs';

import { Styled } from './';
import { Lineitem } from 'types';
import { useI18n } from 'contexts/i18n';

interface LineItemDiscountsProps {
  lineItem: Lineitem;
}

const LineItemDiscounts: FC<LineItemDiscountsProps> = ({ lineItem }) => {
  const i18n = useI18n();

  const hasSubscription = lineItem.isSubscribed;
  const hasBulkDiscount = lineItem.isHavingBulkDiscountAdjustments;
  const hasDSODiscount = lineItem.isHavingDSODiscountAdjustments;
  const hasCoupon = !!lineItem.couponCode;
  const hasPercentageSaved = parseInt(lineItem.discountPercentage) > 0;

  const hasAnyDiscount =
    hasSubscription ||
    hasBulkDiscount ||
    hasDSODiscount ||
    hasCoupon ||
    hasPercentageSaved;

  if (!hasAnyDiscount) return null;

  return (
    <Styled.LineItemDiscountsWrapper>
      {hasSubscription && (
        <Styled.SubscriptionDisclaimer>
          {`${i18n['Subscription:']} ${lineItem.quantity} ${
            lineItem.quantity === 1 ? i18n['unit'] : i18n['units']
          } ${i18n['delivered and billed every']} ${
            lineItem.subscriptionTitle
              ? i18n[lineItem.subscriptionTitle] || lineItem.subscriptionTitle
              : ''
          }`}
        </Styled.SubscriptionDisclaimer>
      )}
      {hasBulkDiscount && (
        <Styled.DiscountContainer>
          <Styled.AvailableDiscounts>
            <div>{lineItem.bulkDiscountPromoTitle}</div>
          </Styled.AvailableDiscounts>
        </Styled.DiscountContainer>
      )}
      {hasDSODiscount && (
        <Styled.DiscountContainer>
          <Styled.AvailableDiscounts>
            <div>{lineItem.dsoDiscountPromoTitle}</div>
          </Styled.AvailableDiscounts>
        </Styled.DiscountContainer>
      )}
      {hasCoupon && (
        <Styled.CouponCode>
          <BsFillTagFill size="14px" />
          <Styled.DiscountAmount>{lineItem.couponCode}</Styled.DiscountAmount>
        </Styled.CouponCode>
      )}
      {hasPercentageSaved && (
        <Styled.PercentageSaved>
          {lineItem.discountPercentage}% {i18n['Saved']}
        </Styled.PercentageSaved>
      )}
    </Styled.LineItemDiscountsWrapper>
  );
};

export default LineItemDiscounts;
